import './ModalCategory.scss';

import * as formik from 'formik';
import * as yup from 'yup';

import { Alert, Modal } from 'react-bootstrap';
import { useEffect, useMemo, useRef, useState } from 'react';

import AppButton from '../../../commons/buttons/AppButton';
import AppInputV2 from '../../../commons/inputs/AppInputV2';
import AppLinkButton from '../../../commons/buttons/AppLinkButton';
import CategoryAPI from '../CategoryAPI';
import CompanyAPI from '../../company/CompanyAPI';
import { Form } from 'react-bootstrap';
import HallAppCenterContainer from '../../../commons/containers/HallAppCenterContainer';
import HallAppToast from '../../../commons/HallAppToast';
import { compressImage } from '../../../commons/util/HallAppUtil';
import noImg from '../../../assets/images/no-img.jpg';
import { useNavigate } from 'react-router-dom';

function ModalCategory({ closeShow, show, findAllCategories, categorySelected }) {
  const [initialValues, setInitialValues] = useState({ category: '' });
  const [imgLogo, setImgLogo] = useState();
  const [isLoading, setLoading] = useState(false);

  const fileInputRef = useRef(null);

  const { Formik } = formik;

  const schema = yup.object().shape({
    category: yup
      .string()
      .required('Informe o nome da categoria')
      .max(50, 'Categoria deve ter no máximo 50 caracteres'),
  });

  const categoryAPI = new CategoryAPI();
  const companyAPI = new CompanyAPI();

  const isEditing = useMemo(
    () => categorySelected != null && Object.keys(categorySelected).length > 0,
    [categorySelected]
  );

  const title = isEditing ? 'Editar categoria' : 'Adicionar categoria';

  const create = async (values, { resetForm }) => {
    const data = {
      name: values.category,
      companyId: companyAPI.getCompanyManagment().id,
    };
    const formData = new FormData();
    formData.append('dto', new Blob([JSON.stringify(data)], { type: 'application/json' }));

    if (imgLogo !== null && imgLogo !== undefined) {
      const logoCompress = await compressImage(imgLogo);
      formData.append('imgCategory', logoCompress);
    }

    setLoading(true);
    try {
      if (isEditing) {
        await categoryAPI.update(categorySelected.id, formData);
      } else {
        await categoryAPI.create(formData);
        resetForm();
        setImgLogo(null);
      }

      HallAppToast.success();
      if (findAllCategories) findAllCategories();
      closeShow();
    } catch (_) {
      HallAppToast.genericError();
    } finally {
      setLoading(false);
    }
  };

  function handleChangeImgLogo(e) {
    const file = e.target.files?.[0];
    if (file) setImgLogo(file);
  }

  useEffect(() => {
    if (isEditing) {
      setInitialValues({ category: categorySelected.name || '' });
    } else {
      setInitialValues({ category: '' });
      setImgLogo(undefined);
    }
  }, [isEditing, categorySelected]);

  const navigate = useNavigate();
  const toSuggestion = () => navigate('/servicos-sugeridos');

  const previewSrc =
    (imgLogo && URL.createObjectURL(imgLogo)) || categorySelected?.logo || noImg;

  return (
    <Modal
      show={show}
      centered
      onHide={closeShow}
      className="hallapp-modal category-modal"
      aria-labelledby="category-modal-title"
    >
      <Modal.Header closeButton className="category-modal__header">
        <Modal.Title id="category-modal-title">{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <HallAppCenterContainer>
          <Alert key="info" variant="info" className="category-modal__hint">
            Use nomes descritivos como “Cabelo”, “Maquiagem” ou “Unhas” para organizar seus serviços.
          </Alert>

          <Formik
            validationSchema={schema}
            onSubmit={create}
            initialValues={initialValues}
            enableReinitialize
          >
            {({ handleSubmit, handleChange, values, touched, errors }) => (
              <Form noValidate onSubmit={handleSubmit} className="category-form">
                <div className="category-form__image">
                  <img
                    src={previewSrc}
                    alt="Prévia da imagem da categoria"
                    className="category-form__image-preview"
                  />
                  <div className="category-form__image-actions">
                    <AppLinkButton
                      name={imgLogo ? 'Trocar imagem' : 'Adicionar imagem'}
                      onClick={() => fileInputRef.current?.click()}
                      size="md"
                      variantStyle="outline"
                    />
                    {imgLogo && (
                      <AppLinkButton
                        name="Remover"
                        onClick={() => {
                          setImgLogo(undefined);
                          if (fileInputRef.current) fileInputRef.current.value = '';
                        }}
                        size="md"
                        variantStyle="ghost"
                      />
                    )}
                  </div>
                </div>

                <input
                  id="file-upload-logo"
                  ref={fileInputRef}
                  type="file"
                  accept="image/*"
                  onChange={handleChangeImgLogo}
                  style={{ display: 'none' }}
                />

                <AppInputV2
                  errors={errors}
                  isRequired
                  touched={touched}
                  name="category"
                  onChange={handleChange}
                  value={values.category}
                  type="text"
                  label="Nome da categoria"
                  placeholder="Ex.: Cabelo"
                />

                <div className="category-form__actions">
                  <AppButton
                    type="submit"
                    name={isEditing ? 'Salvar alterações' : 'Adicionar'}
                    width="100%"
                    loading={isLoading}
                    disabled={isLoading}
                  />
                  <AppLinkButton
                    onClick={toSuggestion}
                    name="Ver sugestões de categorias e serviços"
                    width="100%"
                  />
                </div>
              </Form>
            )}
          </Formik>
        </HallAppCenterContainer>
      </Modal.Body>
    </Modal>
  );
}

export default ModalCategory;